/* np-lab.js — behaviour for sections/new-lab.liquid.
   Note: the hero kicker's article count ("The Lab · N articles") is left as
   the server-rendered total; this file must never overwrite it with a count
   derived from only the current page's cards.
   Search (15 Oct 2026, Adam: "Add a search in the articles page"): typing filters the cards on the page (title, summary,
   topic, author; every word must match) together with the topic chips. Shopify's predictive search then adds matching
   articles from the rest of the archive as extra cards, built with textContent only. */
(function () {
  "use strict";
  var chips = Array.prototype.slice.call(document.querySelectorAll(".nl-chip"));
  var cards = Array.prototype.slice.call(document.querySelectorAll(".nl-card"));
  var results = document.getElementById("nl-results");
  var moreWrap = document.getElementById("nl-morewrap");
  var moreBtn = document.getElementById("nl-more");
  var input = document.getElementById("nl-q");
  var clearBtn = document.getElementById("nl-q-clear");
  var status = document.getElementById("nl-search-status");
  var noRes = document.getElementById("nl-noresults");
  var noResQ = document.getElementById("nl-noresults-q");
  var PAGE = 6;
  var topic = "All";
  var limit = PAGE;
  var query = "";
  var remote = [];          /* cards added from the archive for the current query */
  var searching = false;

  /* cards come from several blogs — order the grid newest first */
  var grid = document.querySelector(".nl-grid");
  if (grid) {
    cards.sort(function (a, b) { return (+b.getAttribute("data-date") || 0) - (+a.getAttribute("data-date") || 0); });
    cards.forEach(function (c) { grid.appendChild(c); });
  }

  function norm(s) { return (s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/\s+/g, " ").trim(); }
  function tagsOf(card) { return (card.getAttribute("data-tags") || "").split("|"); }
  function textOf(card) { if (card.__q == null) card.__q = norm(card.textContent + " " + tagsOf(card).join(" ")); return card.__q; }
  function matchesQuery(card) {
    if (!query) return true;
    var t = textOf(card);
    return norm(query).split(" ").every(function (w) { return t.indexOf(w) > -1; });
  }
  function matches(card) { return (topic === "All" || tagsOf(card).indexOf(topic) > -1) && matchesQuery(card); }
  function plural(n) { return n + (n === 1 ? " article" : " articles"); }

  function apply() {
    var all = cards.concat(remote);
    var matched = all.filter(matches);
    var show = query ? matched.length : limit;
    all.forEach(function (c) { c.style.display = "none"; });
    matched.slice(0, show).forEach(function (c) { c.style.display = "flex"; });
    /* the hero kicker carries The Lab's total; this line only counts a chosen topic, so the two never disagree */
    if (results) results.textContent = topic === "All" || query ? "" : topic + " · " + plural(matched.length);
    if (status) {
      status.textContent = query ? plural(matched.length) + " for “" + query + "”" + (topic !== "All" ? " in " + topic : "") + (searching ? " · searching every article" : "") : "";
    }
    if (noRes) { noRes.hidden = !(query && !searching && matched.length === 0); if (noResQ) noResQ.textContent = "“" + query + "”"; }
    var remaining = matched.length - Math.min(show, matched.length);
    if (moreWrap) moreWrap.style.display = remaining > 0 ? "flex" : "none";
    if (moreBtn && remaining > 0) moreBtn.textContent = "Load more articles · " + remaining + " more";
    if (clearBtn) clearBtn.hidden = !query;
    chips.forEach(function (ch) {
      var on = ch.getAttribute("data-topic") === topic;
      ch.classList.toggle("on", on);
      ch.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  /* ---- archive search: Shopify predictive search, articles only ---- */
  var ctrl = null, timer = null;
  function pathOf(u) { try { return new URL(u, location.origin).pathname.replace(/\/$/, ""); } catch (e) { return u; } }
  var onPage = {};
  cards.forEach(function (c) { onPage[pathOf(c.getAttribute("href"))] = true; });
  function el(tag, style, text) { var e = document.createElement(tag); if (style) e.setAttribute("style", style); if (text != null) e.textContent = text; return e; }
  function ukDate(s) {
    var d = new Date(s); if (isNaN(d)) return "";
    var m = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][d.getMonth()];
    return ("0" + d.getDate()).slice(-2) + " " + m + " " + d.getFullYear();
  }
  function stripHtml(h) { var d = document.createElement("div"); d.innerHTML = h || ""; return (d.textContent || "").replace(/\s+/g, " ").trim(); }
  function buildCard(a) {
    var tags = Array.isArray(a.tags) ? a.tags : [];
    var card = el("a"); card.className = "nl-card nl-card--remote"; card.href = pathOf(a.url);
    card.setAttribute("data-tags", tags.join("|"));
    var media = el("span", "position:relative;display:block;aspect-ratio:16/10;background:#EDEBE6;overflow:hidden");
    var src = a.image || (a.featured_image && a.featured_image.url);
    if (src) { var img = el("img", "position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block"); img.alt = ""; img.loading = "lazy"; img.src = src + (src.indexOf("?") > -1 ? "&" : "?") + "width=800"; media.appendChild(img); }
    media.appendChild(el("span", "position:absolute;top:14px;left:14px;background:rgba(255,255,255,.94);color:#0B0B0B;padding:6px 11px;border-radius:100px;font:500 11px/1 'Kode Mono',ui-monospace,monospace;letter-spacing:.12em;text-transform:uppercase", tags[0] || "The Lab"));
    var body = el("span", "display:flex;flex-direction:column;flex:1;padding:24px 26px 26px");
    body.appendChild(el("span", "display:flex;gap:14px;font:500 11px/1 'Kode Mono',ui-monospace,monospace;letter-spacing:.12em;text-transform:uppercase;color:rgba(11,11,11,.62);margin-bottom:14px", ukDate(a.published_at)));
    body.appendChild(el("span", "display:block;font:700 21px/1.24 'Xenon Nue','Helvetica Neue',Helvetica,Arial,sans-serif;letter-spacing:.004em;margin-bottom:12px;text-wrap:pretty", a.title || ""));
    var blurb = stripHtml(a.summary_html || a.body || "").replace(/ — /g, ", ").replace(/—/g, ", ");
    if (blurb.length > 130) blurb = blurb.slice(0, 127).replace(/\s+\S*$/, "") + "...";
    body.appendChild(el("span", "display:block;font:400 14.5px/1.6 Inter,system-ui,sans-serif;color:rgba(11,11,11,.66);margin-bottom:22px;text-wrap:pretty", blurb));
    var foot = el("span", "display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:auto;padding-top:18px;border-top:1px solid rgba(11,11,11,.09)");
    foot.appendChild(el("span", "font:500 13px/1.4 Inter,system-ui,sans-serif;color:rgba(11,11,11,.66)", a.author || ""));
    foot.appendChild(el("span", "font:500 11px/1 'Kode Mono',ui-monospace,monospace;letter-spacing:.12em;text-transform:uppercase;color:#0B0B0B", "Read →"));
    body.appendChild(foot);
    card.appendChild(media); card.appendChild(body);
    card.__q = norm((a.title || "") + " " + blurb + " " + tags.join(" ") + " " + (a.author || ""));
    return card;
  }
  function clearRemote() { remote.forEach(function (c) { if (c.parentNode) c.parentNode.removeChild(c); }); remote = []; }
  function searchArchive(q) {
    if (ctrl) ctrl.abort();
    if (q.length < 2 || !window.fetch) { searching = false; apply(); return; }
    ctrl = window.AbortController ? new AbortController() : null;
    searching = true; apply();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var url = root + "search/suggest.json?q=" + encodeURIComponent(q) +
      "&resources%5Btype%5D=article&resources%5Blimit%5D=10&resources%5Boptions%5D%5Bfields%5D=title,body,tag,author";
    fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error("bad response")); })
      .then(function (data) {
        if (q !== query) return;
        clearRemote();
        var arts = (data && data.resources && data.resources.results && data.resources.results.articles) || [];
        arts.forEach(function (a) {
          if (!a || !a.url || onPage[pathOf(a.url)]) return;
          var c = buildCard(a);
          if (grid) grid.appendChild(c);
          remote.push(c);
        });
        searching = false; apply();
      })
      .catch(function (e) { if (e && e.name === "AbortError") return; searching = false; apply(); });
  }

  function setQuery(q, immediate) {
    query = (q || "").replace(/\s+/g, " ").trim();
    clearTimeout(timer);
    if (!query) { if (ctrl) ctrl.abort(); clearRemote(); searching = false; limit = PAGE; apply(); return; }
    apply();
    timer = setTimeout(function () { searchArchive(query); }, immediate ? 0 : 280);
  }
  if (input) {
    input.addEventListener("input", function () { setQuery(input.value, false); });
    if (input.form) input.form.addEventListener("submit", function (e) { e.preventDefault(); setQuery(input.value, true); });
    input.addEventListener("keydown", function (e) { if (e.key === "Escape" && input.value) { input.value = ""; setQuery("", true); } });
  }
  if (clearBtn) clearBtn.addEventListener("click", function () { input.value = ""; setQuery("", true); input.focus(); });

  chips.forEach(function (ch) {
    ch.addEventListener("click", function () { topic = ch.getAttribute("data-topic"); limit = PAGE; apply(); });
    var t = ch.getAttribute("data-topic");
    if (t !== "All" && !cards.some(function (c) { return tagsOf(c).indexOf(t) > -1; })) ch.style.display = "none";
  });
  if (moreBtn) moreBtn.addEventListener("click", function () { limit = 9999; apply(); });

  /* reading-collection cards: real counts + Browse -> filter */
  Array.prototype.slice.call(document.querySelectorAll(".nl-colcount")).forEach(function (el2) {
    var t = el2.getAttribute("data-topic");
    var n = cards.filter(function (c) { return tagsOf(c).indexOf(t) > -1; }).length;
    el2.textContent = (n < 10 ? "0" + n : n) + (n === 1 ? " article" : " articles");
    if (n === 0 && el2.parentElement) el2.parentElement.style.display = "none";
  });
  Array.prototype.slice.call(document.querySelectorAll(".nl-browse")).forEach(function (b) {
    b.addEventListener("click", function () {
      topic = b.getAttribute("data-topic"); limit = PAGE; apply();
      var articlesEl = document.getElementById("nl-articles");
      if (articlesEl) articlesEl.scrollIntoView({ behavior: "smooth" });
    });
  });

  /* honour ?topic= and ?q= like the design */
  var params = new URLSearchParams(location.search);
  var qt = params.get("topic");
  if (qt && chips.some(function (ch) { return ch.getAttribute("data-topic") === qt; })) topic = qt;
  var qq = params.get("q");
  if (qq && input) { input.value = qq; setQuery(qq, true); } else apply();
})();
